module.exports = new __parcel__URL__("cover-photo.00961592.svg").toString();